<aside [class.collapsed]="sidebarCollapsed">
  <section class="logo">
    <img src="../../../assets/images/logo_blue_white.svg" alt="Innovian">
  </section>
  <nav id="left-nav-wrapper">
    <ul class="list-group list-group-flush left-nav-list">
      <a routerLink="/dashboard" class="list-group-item list-group-item-action" routerLinkActive="active">
        <fa-icon [icon]="icons.dashboard"></fa-icon>
        <span>Dashboard</span>
      </a>
      <a routerLink="/reports" class="list-group-item list-group-item-action" routerLinkActive="active">
        <fa-icon [icon]="icons.reports"></fa-icon>
        <span>Reports</span>
      </a>
      <a routerLink="/tags" class="list-group-item list-group-item-action" routerLinkActive="active" *appShowIfUserCan="{permission: 'tags/read'}">
        <fa-icon [icon]="icons.tags"></fa-icon>
        <span>Tags</span>
      </a>
      <a routerLink="/pages" class="list-group-item list-group-item-action" routerLinkActive="active" *appShowIfUserCan="{permission: 'pages/read'}">
        <fa-icon [icon]="icons.pages"></fa-icon>
        <span>Pages</span>
      </a>
      <a routerLink="/rules" class="list-group-item list-group-item-action" routerLinkActive="active" *appShowIfUserCan="{permission: 'rules/read'}">
        <fa-icon [icon]="icons.rules"></fa-icon>
        <span>Rules</span>
      </a>
      <a routerLink="/pii-triggers" class="list-group-item list-group-item-action" routerLinkActive="active" *appShowIfUserCan="{permission: 'pii/read'}">
        <fa-icon [icon]="icons.pii"></fa-icon>
        <span>PII Triggers</span>
      </a>
      <a routerLink="/settings" class="list-group-item list-group-item-action" routerLinkActive="active" *appShowIfUserCan="{permission: 'properties/write', global: true}">
        <fa-icon [icon]="icons.settings"></fa-icon>
        <span>Settings</span>
      </a>
    </ul>
    <button (click)="toggleSidebar()" class="btn toggleCollapse">
      <fa-icon [icon]="icons.collapse"></fa-icon>
    </button>
  </nav>
</aside>
<section>
  <app-top-nav></app-top-nav>
  <main role="main">
    <router-outlet></router-outlet>
  </main>
</section>
<app-toast-list></app-toast-list>
